<template>
  <span>
    <button class="button is-small is-danger" @click="visibleModal = true">
      Elimina
    </button>
    <b-modal :active.sync="visibleModal" has-modal-card>
      <div class="modal-card" style="width: auto">
        <section class="modal-card-body">
          <p>
            Sicuri di voler eliminare questo elemento? L'azione è irreversibile.
          </p>
        </section>

        <footer class="modal-card-foot">
          <button class="button is-primary" @click="visibleModal = false">
            Annulla
          </button>
          <button class="button" @click="submit()">Elimina</button>
        </footer>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    submitAction: {
      type: Function,
      required: true
    },
    redirectRoute: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visibleModal: false
    }
  },
  methods: {
    async submit() {
      await this.submitAction(this.id)
      this.$toast.open({
        message: "Eliminato con successo",
        type: "is-danger"
      })
      this.$emit("done")
      this.visibleModal = false
    }
  }
}
</script>
